import {OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {select} from '@angular-redux/store';
import {Observable} from 'rxjs';
import {CommonComponent, Config, LoggerService} from '../../../modules/hbs-services';

/**
 * adds abstract onConfigChanged() method
 */
export abstract class OnConfigComponent extends CommonComponent implements OnInit, OnDestroy {

    @select('config')
    protected config$: Observable<Config>;

    protected ngOnDestroy$: Subject<any> = new Subject();

    abstract onConfigChanged(config: Config);

    constructor(protected logger: LoggerService) {
        super(logger)
    }

    ngOnInit(): void {
        this.config$.takeUntil(this.ngOnDestroy$).subscribe((config: Config) => {
            this.onConfigChanged(config);

        });
    }

    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();

    }

}
